import { athletes } from "./people/athletes";
import { camps } from "./competition/camps";
import { calendar } from "./competition/calendar";
import { champions } from "./competition/champions";
import { classes } from "./people/classes";
import { collisions } from "./forecast/collisions";
import { dbm } from "./records/dbm";
import { eligibility } from "./people/eligibility";
import { entries } from "./competition/entries";
import { entitySnapshots } from "./records/entity-snapshots";
import { futures } from "./forecast/futures";
import { international } from "./records/international";
import { load } from "./client/load";
import { tournamentMatches } from "./competition/matches";
import { plan } from "./forecast/plan";
import { predictions } from "./forecast/predictions";
import { rankings } from "./competition/rankings";
import { referees } from "./people/referees";
import { results } from "./competition/results";
import { roster } from "./people/roster";
import { snapshots } from "./records/snapshots";
import { sources } from "./records/sources";
import { tournaments } from "./competition/tournaments";

// `snapshots` keeps the legacy per-athlete namespace; the new generic entity
// snapshot list lives under `entitySnapshots`. `tournamentMatches` is the BI
// shell's view of `tournament_matches`; the existing `useMatches` from the
// game service stays untouched.
export const bisApi = {
	eligibility,
	collisions,
	champions,
	predictions,
	snapshots,
	athletes,
	roster,
	plan,
	calendar,
	camps,
	referees,
	futures,
	classes,
	load,
	tournaments,
	// BI shell record lists (12 categories).
	rankings,
	entries,
	matches: tournamentMatches,
	results,
	dbm,
	international,
	entitySnapshots,
	sources,
};
